export default __webpack_public_path__ + "media/fonts/foundation-icons/foundation-icons-a02a0dbbb4c161b4e2f1c5b3322f93e9.svg";